import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ParseUrlService } from './parse-url.service';
import { AuthStorageService } from './auth-storage.service';
import { UserService } from '../user/user.service';
import { User } from '../user/user';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment.production'; 
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { throwError as observableThrowError, Observable } from 'rxjs';

import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private parseUrlService: ParseUrlService, private authStorage: AuthStorageService, private _http: HttpClient, private userService: UserService, private http: HttpClient, private router: Router, @Inject(PLATFORM_ID) private platformId: object) {
  }
  user!: User;
 revokeTokenURL = environment.revokeToken;
 clientId =  environment.clientId;



  chceckAccessToken(): boolean {
    const params = this.parseUrlService.getParamsObjectFromHash();
    if (params && params['access_token']) {
      this.authStorage.save(params['access_token']);
      return true;
    } else {
      return false;
    }
  }



 
  removeParametrs() {
    const url: string = this.router.url.substring(0, this.router.url.indexOf('#'));
    this.router.navigateByUrl(url);
  }




  revokeToken(): Observable<any> {

    const httpOptionsRevoke = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
   
    return this.http.post<any>(this.revokeTokenURL, 'token=' + this.authStorage.getToken() + '&client_id=' + this.clientId, httpOptionsRevoke);
  }


  haveAccessToken(): boolean {
    const at = this.authStorage.getToken();
    return at != null;
  }

  getAccessToken(): string {
    return this.authStorage.getToken();
  }

  clearAccessToken() {
    this.authStorage.clear();
  }

  logout() { 
    this.authStorage.clear();
if(window && isPlatformBrowser(this.platformId)){
    const currentUrl = window.location.href;

    // Extrahujte doménu z URL pomocí regulárního výrazu
    const domainMatch = currentUrl.match(/^(?:https?:\/\/)?([^\/]+)\//);

    // Pokud existuje shoda, vezměte první skupinu (doménu)
    const domain = domainMatch ? domainMatch[1] : '';

    let logoutUrl: string;

    // Porovnejte doménu bez ohledu na cestu za lomítkem
    if (domain.includes('localhost')) {
      logoutUrl = 'https://test.logical.codes/users/logout';
    } else if (domain.includes('test.logical.finance')) {
      logoutUrl = 'https://test.logical.codes/users/logout';
    } else {
      logoutUrl = 'https://logical.codes/users/logout';
    }
 
  }
  }
}
